<template>
  <div class="bg"
       @scroll="scrollfn"
       ref="bigbox">
    <div class="main"
         ref="main">
      <div class="img-box"
           v-for="(item, i) in imgList"
           :key="i">
        <img :src="item.img"
             class="img"
             v-if="item.show" />
        <div class="box"
             v-if="i == 2">
          <!-- <swiper :options="swiperOption"
                  class="swiper2">
            <swiper-slide v-for="(item, index) in 2"
                          :key="index"
                          class="swiper-slide">
              <div class="inside">
                <img :src="require(`@/assets/img/culturalCourses/${index + 1}.png`)"
                     class="img" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div> -->

          <img :src="require(`@/assets/img/culturalCourses/10.png`)"
               style=" height: 100%;" />
        </div>

        <a href="tel:15915856919"
           class="call"
           v-if="showCall&&(i+1==imgList.length)"></a>
      </div>

      <div class="bottom">
        <span>© 重本紫藤教育科技（广州）有限公司 版权所有。</span>
        <span @click="goUrl">粤ICP备2021074338号</span>
      </div>
    </div>
  </div>
</template>
  
  <script>
import api from "@/api";
const wx = require("weixin-js-sdk");
export default {
  mounted() {
    document.title = "重本·紫腾";
  },
  data() {
    return {
      swiperOption: {
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
        // 设置轮播
        // effect: 'flip',
        effect: "slide",
        // 滑动速度
        speed: 2000,
        // 滑动方向
        direction: "horizontal",
        // 分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
      },
      isShow: false,
      fake: [
        {
          top: "top: 15.7333rem",
        },
        {
          top: "top: 41.2rem",
        },
        {
          top: "top: 70.4267rem",
        },
        {
          top: "top: 78.5333rem",
        },
      ],
      showCall: false,
      showNum: 2,
      imgList: [
        {
          img: require("@/assets/img/culturalCourses/1.png"),
          show: true,
        },
        {
          img: require("@/assets/img/culturalCourses/2.png"),
          show: true,
        },
        {
          img: require("@/assets/img/culturalCourses/3.png"),
          show: true,
        },
        {
          img: require("@/assets/img/culturalCourses/4.png"),
          show: true,
        },
        {
          img: require("@/assets/img/culturalCourses/5.png"),
          show: false,
        },
        {
          img: require("@/assets/img/culturalCourses/6.png"),
          show: false,
        },
        {
          img: require("@/assets/img/culturalCourses/7.png"),
          show: false,
        },
        {
          img: require("@/assets/img/culturalCourses/8.png"),
          show: false,
        },
        {
          img: require("@/assets/img/culturalCourses/9.png"),
          show: false,
        }
      ]
    };
  },
  methods: {
    scrollfn() {
      if (
        this.$refs.main.offsetHeight -
        (this.$refs.bigbox.scrollTop + this.$refs.bigbox.offsetHeight) <
        50
      ) {
        this.showNum++;
        if (this.showNum > this.imgList.length - 1) return;
        console.log(this.showNum);
        this.imgList[this.showNum].show = true;
        if (this.showNum == this.imgList.length - 1) {
          this.showCall = true;
        }
      }
    },
    go(val, i) {
      // let a = document.createElement('a')
      // a.href = `#No${i}`
      // a.click()
      document.querySelector(`#No${i}`).scrollIntoView(true);
    },
    id(id) {
      return "No" + id;
    },
    goActivity(item) {
      if (item.link) {
        window.location.href = item.link;
      }
    },
    goUrl() {
      window.open('https://beian.miit.gov.cn')
    },
    setShare() {
      let url = "https://www.zhongbenziteng.com/gf-m/index.html"; // 显示页面地址
      api.wechat.jsSdkConfig2({ params: { url } }).then(function (res) {
        // 微信小程序接口起调配置
        console.log(res.data.data);
        console.log(wx);
        wx.config({
          debug: false,
          appId: res.data.data.appId,
          timestamp: res.data.data.timestamp,
          nonceStr: res.data.data.noncestr,
          signature: res.data.data.signature,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "getLocation",
            "openLocation",
          ],
        });
        wx.ready(function () {
          console.log("????");
          wx.checkJsApi({
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              console.log(res);
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            },
          });
          wx.onMenuShareTimeline({
            title: "重本·紫腾     春季高考 依学考", // 分享标题
            desc: "圆梦理想大学", // 分享描述
            link: "https://www.zhongbenziteng.com/zt-pc/mgaozhi.html#/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              "https://boss-prd.oss-cn-shenzhen.aliyuncs.com/otherFile/web/202106/f505dc06-a43f-4799-8bb1-c77c517d78cc.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              alert("分享成功");
            },
          });
          wx.onMenuShareAppMessage({
            title: "重本·紫腾     春季高考 依学考", // 分享标题
            desc: "圆梦理想大学", // 分享描述
            link: "https://www.zhongbenziteng.com/zt-pc/mgaozhi.html#/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl:
              "https://boss-prd.oss-cn-shenzhen.aliyuncs.com/otherFile/web/202106/f505dc06-a43f-4799-8bb1-c77c517d78cc.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              alert("分享成功");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
            },
          });
        });
      });
    },
  },
};
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .bg {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow: scroll;
  }
  
  .img {
    display: block;
    width: 100%;
  }
  
  .none {
    /* display: none; */
    position: absolute;
    left: 0;
    width: 100%;
    height: 0;
  }
  
  .absoluteBox {
    position: absolute;
    top: 1173px;
    left: 0;
    width: 100%;
    height: 120px;
    box-sizing: border-box;
  }
  
  .fixedBox {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 120px;
    /* background: url('~@gaozhi/fixed.png') no-repeat; */
    background-size: 100%;
  }
  
  .fake-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 120px;
    padding: 0 25px;
    box-sizing: border-box;
  }
  
  .fake {
    width: 160px;
    height: 80px;
  }
  
  .clickbox {
    position: absolute;
    top: 2976px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    display: flex;
    width: 326px;
    height: 214px;
    border-radius: 5px;
    overflow: hidden;
  }
  
  .option {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 52px;
    font-size: 12px;
    color: #666666;
    background: #e2e2e2;
  }
  
  .selected {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 53px;
    font-size: 12px;
    color: #fff;
    background: #db4527;
  }
  
  .right {
    width: 245px;
    height: 160px;
  }
  
  .right>img {
    width: 100%;
    object-fit: contain;
  }
  
  /* 活动 */
  .activity {
    position: absolute;
    top: 4314px;
    left: 50%;
    width: 345px;
    height: 447px;
    padding: 0 15px;
    box-sizing: border-box;
    transform: translateX(-50%);
  }
  
  .activity-big {
    display: flex;
    width: 100%;
    height: 90px;
    margin-bottom: 10px;
    border-radius: 15px;
    overflow: hidden;
  }
  
  .activity-big:nth-child(4) {
    margin-bottom: 15px;
  }
  
  .activity-small {
    width: 50%;
    height: 100%;
  }
  
  .oneOnOne {
    width: 315px;
    height: 42px;
    border-radius: 21px;
  }
  
  .img-box {
    position: relative;
  }
  
  .swiper {
    width: 100%;
    height: 100%;
  }
  
  .box {
    position: absolute;
    top: 114px;
    left: 50%;
    transform: translateX(-50%);
    width: 92%;
    height: 455px;
    border-radius: 0.13333rem;
    overflow: auto;
    background: #fff;
  }

  .swiper2 {
    width: 100%;
    height: 100%;
  }
  
  .swiper-slide {
    overflow: hidden;
  }
  
  .inside {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height:100%
  }
  
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .inside-img {
    width: 49%;
    height: 100%;
    object-fit: cover;
  }
  
  .swiper3 {
    width: 100%;
    height: 100%;
  }
  
  .swiper-pagination {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  
  .save {
    width: 80px;
    height: 37px;
    border-radius: 19px;
  }
  
  .rightNow {
    width: 171px;
    height: 37px;
    border-radius: 19px;
  }
  
  .tips {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 109;
  }
  
  .call {
    position: absolute;
    bottom: 317px;
    /* top: 6245.625px; */
    left: 25px;
    display: block;
    width: 50%;
    height: 0.61333rem;
    /* background-color: rgba(0, 0, 0, 0.5); */
  }
  
  .call2 {
    position: absolute;
    bottom: 83px;
    left: 25px;
    /* display: block;/ */
    /* width: 100%; */
    /* height: 0.61333rem; */
    /* background-color: rgba(0, 0, 0, 0.5); */
    /* background-color: #000; */
  }
  
  .bottom {
    width: 100%;
    font-size: 10px;
    /* line-height: 30px; */
    color: #999;
    text-align: center;
    background-color: #4a4a4a;
  }
  
  .beian {
    color: #999;
    text-decoration: none;
  }
  
  .beian:hover {
    text-decoration: underline;
  }
  
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .mask-center {
    position: absolute;
    top: 245px;
    left: 50%;
    width: 232px;
    height: 290px;
    transform: translateX(-50%);
  }
  
  .mask-img {
    width: 100%;
    height: 100%;
  }
  
  .closeMask {
    position: absolute;
    bottom: 15px;
    left: 50%;
    width: 20px;
    height: 20px;
    transform: translateX(-50%);
  }
  </style>
  <style>
  .my-bullet {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    background-color: #b2aba1;
    border-radius: 50%;
    opacity: 0.4;
  }
  
  .my-bullet-active {
    background: #fff;
    opacity: 1;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/cc.vue